// extracted by mini-css-extract-plugin
export default {"label":"Input_label__Ct6Wr","inputIcon":"Input_inputIcon__gP-q9","selectLabel":"Input_selectLabel__YXB7u"};